const upcomingInstallmentsSchema = [
  {
    id: "amount",
    label: "Amount",
    type: "currency",
  },
  {
    id: "dueDate",
    label: "Due Date",
    type: "date",
    config: {
      formatType: "long",
    },
  },
];

export default upcomingInstallmentsSchema;
